<template>
  <div class="test-reservation-wrap">
    <div>
      <div class="my-breadcrumb pdb20" v-if="step == 1">
        <span>我的位置：</span>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/user/index' }">测试与分析</el-breadcrumb-item>
          <el-breadcrumb-item>云现场</el-breadcrumb-item>
          <el-breadcrumb-item>云现场-AFM</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="reservation-info" v-if="step == 1">
        <div class="my-card-title">预约须知</div>
        <div class="content">
          1. 云现场机时有限，下单前请先跟工作人员联系，沟通拍摄要求及确认预约时间后再下单。<br>
          2. 可为粉末、块体、薄膜样品，粉末和液体样品需说明制样方法<br>
          3. 云现场机时有限，下单前请先跟工作人员联系，沟通拍摄要求及确认预约时间后再下单。<br>
          4. 块体和薄膜样品长宽在5~30mm之间，厚度在1~10mm之间，表面起伏应小于5um，备注好测试面。<br>
          5. 粉末样品质量不少于20mg。<br>
          6. 液体样品体积不少于1mL。
        </div>
      </div>
      <div class="reservation-step">
        <div class="my-step">
          <div class="step-icon step-icon-sel">1</div>
          <p class="step-name step-name-sel">下单：原子力显微镜（AFM）云测试</p>
          <img src="~@/assets/images/step_next_icon.png" class="step-arrow" alt="">
          <div :class="['step-icon', { 'step-icon-sel': step >= 2 }]">2</div>
          <p :class="['step-name', { 'step-name-sel': step >= 2 }]">附加信息</p>
          <img src="~@/assets/images/step_next_icon.png" class="step-arrow" alt="">
          <div :class="['step-icon', { 'step-icon-sel': step >= 3 }]">3</div>
          <p :class="['step-name', { 'step-name-sel': step >= 3 }]">支付订单</p>
        </div>
        <div class="step-form-card" v-if="step == 1">
          <div class="form-header">
            <div class="sample-list">
              <div v-for="(item, index) in sampleList" :key="index"
                :class="['sample', { 'sample-sel': currentSampleIndex == index }]" @click="currentSampleIndex = index">
                <span>{{ letters[index] }}组实验样品</span><span class="close" @click="delSample(index)">×</span>
              </div>
            </div>
            <button type="button" class="my-btn addSample" @click="addSample">新增样品</button>
          </div>
          <el-form autoComplete="on" element-loading-text="给我一点时间" label-position="right" ref="form" label-width="120px"
            label-suffix="：">
            <div v-for="(sample, sampleIdx) in sampleList" :key="sampleIdx">
              <div class="my-form" v-if="currentSampleIndex == sampleIdx">
                <el-form-item v-for="(form, index) in sample.formList" :label="form.config.name"
                  :key="`${sampleIdx}_${index}_${form.id}_${form.type}`"
                  :prop="`${sampleIdx}_${index}_${form.id}_${form.type}`">
                  <component :is="`form-${form.type}`" v-model="form.value" :config="form.config"></component>
                  <p class="common_tip" v-if="form.config.tips">提示：{{ form.config.tips }}</p>
                </el-form-item>
              </div>
            </div>
          </el-form>

        </div>
        <div class="attr-info" v-if="step == 2">
          <el-form autoComplete="on" element-loading-text="给我一点时间" label-position="right" ref="form" label-width="0">
            <div class="my-form">

              <div class="form-item">
                <label>是否加急</label>
                <div>
                  <el-form-item>
                    <el-radio-group v-model="form.urgent">
                      <el-radio :label="1">是</el-radio>
                      <el-radio :label="0">否</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </div>
              </div>
              <div class="form-item">
                <label>样品回收</label>
                <div>
                  <el-form-item>
                    <el-radio-group v-model="form.recovery">
                      <el-radio :label="0">不回收</el-radio>
                      <el-radio :label="1">回收</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <div class="form-text form-text-red">
                    样品在实验室一般保留3个工作日，若数据有疑问需尽快反馈，以便及时处理。</div>
                </div>
              </div>
              <div class="form-item">
                <label>是否是团队订单</label>
                <div>
                  <el-form-item>
                    <el-radio-group v-model="form.type">
                      <el-radio :label="1">个人订单</el-radio>
                      <el-radio :label="0">团队订单</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <div class="form-text form-text-red mgb10">
                    如选择团队订单则需要团长审核通过。</div>
                </div>
              </div>
              <div class="form-item">
                <label>联系人</label>
                <el-form-item prop="linkman">
                  <el-input type="text" style="width:350px" v-model="form.linkman" placeholder="请输入联系人">
                  </el-input>
                </el-form-item>
              </div>
              <div class="form-item">
                <label>联系电话</label>
                <el-form-item prop="linknum">
                  <el-input type="text" style="width:350px" v-model="form.linknum" placeholder="请输入联系电话">
                  </el-input>
                </el-form-item>
              </div>
              <div class="form-item">
                <label>与之前的测试同设备</label>
                <el-form-item>
                  <el-radio-group v-model="form.same_device">
                    <el-radio :label="0">不需要</el-radio>
                    <el-radio :label="1">需要</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
              <div class="form-item">
                <label>送样方式</label>
                <div>
                  <el-form-item>
                    <el-radio-group v-model="form.sample_type">
                      <el-radio :label="0">邮寄样品</el-radio>
                      <el-radio :label="1">上门取样</el-radio>
                      <el-radio :label="2">自己送样</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <div v-show="form.sample_type == 0" class="sampleSendType1">
                    <p class="title">样品寄送地址</p>
                    <div class="address-list">
                      <div v-for="(item, idx) in addressList" @click="form.sampleSendAddress = item.id"
                        :class="['item', { 'active': form.sampleSendAddress == item.id }]" :key="idx">{{ item.name
                        }}
                      </div>
                    </div>
                    <div class="active-address-detail">
                      <p>{{ currentSampleSendAddress.county }}</p>
                      <p>{{ currentSampleSendAddress.address }}</p>
                      <p class="fwb">联系老师：{{ currentSampleSendAddress.teacher }}</p>
                      <p class="fwb">联系电话：{{ currentSampleSendAddress.phone }}</p>
                    </div>
                  </div>
                  <div v-show="form.sample_type == 1" class="sampleSendType2">
                    <div class="form-item">
                      <label>取样地址</label>
                      <div style="display:flex;align-items: center;column-gap: 10px;">
                        <el-form-item prop="linkman">
                          <el-cascader style="width:350px;" v-model="form.areaArr" placeholder="请选择地址" clearable
                            :props="cascaderProp" :options="areaList">
                          </el-cascader>
                        </el-form-item>
                      </div>
                    </div>
                    <div class="form-item">
                      <label>详细地址</label>
                      <el-form-item prop="linkman">
                        <el-input type="text" style="width:350px" v-model="form.linkman" placeholder="请输入详细地址">
                        </el-input>
                      </el-form-item>
                    </div>
                    <div class="form-item">
                      <label>联系方式</label>
                      <div style="display: flex;align-items: center;column-gap: 10px;">
                        <el-form-item prop="linkman">
                          <el-input type="text" style="width:200px" v-model="form.linkman" placeholder="请输入联系人姓名">
                          </el-input>
                        </el-form-item>
                        <el-form-item prop="linkman">
                          <el-input type="text" style="width:200px" v-model="form.linkman" placeholder="请输入联系人手机号">
                          </el-input>
                        </el-form-item>
                      </div>
                    </div>
                    <div class="form-item" style="position: relative;">
                      <label>取样时间</label>
                      <el-form-item prop="sample_reserve_time">
                        <el-date-picker v-model="form.sample_reserve_time" type="datetime" placeholder="选择日期时间">
                        </el-date-picker>
                      </el-form-item>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-form>
        </div>
        <div class="wait-pay-info" v-if="step == 3">
          <div class="my-card-title">待支付详情</div>
          <div class="content">
            <div class="cost-list">
              <div class="title">原子力显微镜（AFM）云测试</div>
              <div class="cost-item">
                <span>订单费用</span>
                <span>￥5899.3</span>
              </div>
              <div class="cost-item">
                <span>优惠券</span>
                <span style="color: #FF6666;">-￥1.00</span>
              </div>
              <div class="cost-total">
                <span>合计费用</span>
                <span style="color: #FF6666;"> ￥5896.3</span>
              </div>
            </div>
          </div>
        </div>
        <div class="pay-type" v-if="step == 3">
          <div class="my-card-title">支付方式</div>
          <div class="pay-type-wrap">
            <div class="pay-type-title">
              <p>预存支付</p>
              <div class="tip">余额：￥0</div>
            </div>
            <div class="form-check under-line">
              <input class="form-check-input" type="radio" name="pay-type" id="pay-type0" value="0"
                v-model="form.payType">
              <label class="form-check-label custom-label" for="pay-type0">
                <img src="~@/assets/images/balance_pay.png" alt="">个人预存余额<span class="tip"
                  style="margin-left: 15px;">您还没有预存，预存可以一次开票、多次使用，省去每次开票的麻烦！<a href="~@/assets/mine/recharge.html"
                    target="_blank"><i>立即预存</i></a></span>
              </label>
            </div>
            <div class="pay-type-title">
              <p>其他方式</p>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="radio" name="pay-type" id="pay-type1" value="1"
                v-model="form.payType">
              <label class="form-check-label custom-label" for="pay-type1">
                <img src="~@/assets/images/wx_pay.png" alt="">微信支付
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="radio" name="pay-type" id="pay-type2" value="2"
                v-model="form.payType">
              <label class="form-check-label custom-label" for="pay-type2">
                <img src="~@/assets/images/ali_pay.png" alt="">支付宝支付
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="radio" name="pay-type" id="pay-type3" value="3"
                v-model="form.payType">
              <label class="form-check-label custom-label" for="pay-type3">
                <img src="~@/assets/images/credit_pay.png" alt="">信用金支付<span class="tip"
                  style="margin-left: 15px;">0元下单，先测试后付款，
                  快去<a href="~@/assets/mine/index.html?sideBar=1" target="_blank"><i>实名认证</i></a> ，领取你的5000元信用额度</span>
              </label>
            </div>
            <div style="margin-top: 40px;" v-if="form.payType == 3 || form.payType == 0">
              <div class="pay-type-title">
                <p>支付密码</p>
              </div>
              <div class="pay-password">
                <div class="password-inp">
                  <el-input type="password" style="width:200px" v-model="form.password" placeholder="请输入支付密码">
                  </el-input>
                  <i @click="resetPayPassword">忘记密码？</i>
                </div>
                <div class="tip">请输入6位数字支付密码</div>
              </div>
            </div>
          </div>
        </div>
        <div class="settlement-wrap">
          <div class="cost">
            <span class="cost-title">合计费用：</span><span class="cost-num">￥5896.3</span>
            <el-popover placement="top" width="400" trigger="click">
              <div class="dropdown">
                <div class="dropdown-menu">
                  <p class="test-name">原子力显微镜（AFM）云测试</p>
                  <p class="test-item">
                    <span class="test-item-name">微米级粒径</span>
                    <span class="test-item-num">100X1</span>
                  </p>
                  <p class="test-item">
                    <span class="test-item-name">微米级粒径</span>
                    <span class="test-item-num">100X1</span>
                  </p>
                  <p class="total-cost">
                    <span class="total-cost-title">合计费用</span>
                    <span class="total-cost-num">￥5896.3</span>
                  </p>
                </div>
              </div>
              <span class="cost-detail" slot="reference">
                费用明细
              </span>
            </el-popover>
          </div>
          <div class="btns">
            <div class="save-btn">保存草稿</div>
            <div class="save-btn" v-if="step != 1" @click="step--">上一步</div>
            <div class="next-btn" v-if="step != 3" @click="step++">下一步</div>
            <div class="next-btn" v-if="step == 3" id="paySubmit" @click="paySubmit">确认并支付</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 重置支付密码 -->
    <ResetPayPassword :visible.sync="showResetPayPasswordForm" />
    <!-- 预约须知 -->
    <knowledge :visible.sync="showKnowledgeForm" />
    <!-- 付款二维码 -->
    <pay-qrcode :pay="pay" :visible.sync="showQrcodeForm" />
  </div>
</template>

<script>

import { getOrderPreview, setFinish, setDelete } from "@/api/order";
import PayQrcode from '@/components/payQrcode';
import Knowledge from './components/knowledge';
import ResetPayPassword from '@/components/resetPayPassword';

import FormInput from '@/components/form/input' //文本框
import FormTextarea from '@/components/form/textarea' //多行文本
import FormRadio from '@/components/form/radio' //单选框
import FormCheckbox from '@/components/form/checkbox' //多选框
import FormSelect from '@/components/form/select' //下拉框
import FormImage from '@/components/form/image' //单图上传
import FormImages from '@/components/form/images' //多图上传
import FormFile from '@/components/form/file' //文件上传
import FormDate from '@/components/form/date' //日期
import FormDatetime from '@/components/form/datetime' //日期时间
import FormTime from '@/components/form/time' //时间
import FormNumber from '@/components/form/number' //数字输入框
export default {
  name: "OrderProjectAdd",
  components: {
    PayQrcode,
    Knowledge,
    ResetPayPassword,
    FormInput,
    FormTextarea,
    FormRadio,
    FormCheckbox,
    FormSelect,
    FormImage,
    FormImages,
    FormFile,
    FormDate,
    FormDatetime,
    FormTime,
    FormNumber
  },
  props: {},
  data() {
    return {
      form: {
        sample_type: 1,
        sampleSendAddress: 1,
        payType: 0,
        urgent: 0,
        same_device: 0,
        same_order_id: 0,
        linkman: '',
        linknum: '',
        recovery: 0,
        sample_reserve_time: null,
        areaArr: [],
        address: '',
        time: '',
        name: '',
        phone: ''
      },
      pay: {},
      areaList: [],
      cascaderProp: {
        value: 'id',
        label: 'name',
        children: '_child',
        disabled: 'disabled'
      },
      checkbox: [],
      showKnowledgeForm: true,
      showQrcodeForm: false,
      showResetPayPasswordForm: false,
      content: "",
      addressList: [
        {
          id: 1,
          name: '上海办事处',
          county: '上海静安区',
          address: '科技二路72号创新信息大厦A座101',
          teacher: '雷老师',
          phone: '13080900817',
          address: '上海市金山区',
          phone: '021-87511111'
        },
        {
          id: 2,
          name: '北京办事处',
          county: '上海静安区',
          address: '科技二路72号创新信息大厦A座101',
          teacher: '雷老师1',
          phone: '13080900817',
          address: '上海市金山区',
          phone: '021-87511111'
        },
        {
          id: 3,
          name: '广州办事处',
          county: '上海静安区',
          address: '科技二路72号创新信息大厦A座101',
          teacher: '雷老师2',
          phone: '13080900817',
          address: '上海市金山区',
          phone: '021-87511111'
        }
      ],
      step: 1,
      currentSampleIndex: 0,
      letters: "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
      initFormList: [],
      sampleList: [
        {
          formList: []
        }
      ]
    }
  },
  computed: {
    currentSampleSendAddress() {
      return this.addressList.find(item => { return item.id == this.form.sampleSendAddress })
    }
  },
  watch: {
    step(newValue, oldValue) {
      if (newValue == 1 || newValue == 2) {

      }
    }
  },
  mounted() {

  },
  created() {
    this.getOrderPreview()
  },
  methods: {
    getOrderPreview() {
      getOrderPreview({ product_id: 23 }).then(res => {
        this.initFormList = res.data.productList[0].modules
        this.sampleList[0].formList = JSON.parse(JSON.stringify(this.initFormList))
      })
    },
    delSample(index) {
      if (this.sampleList.length == 1) {
        return this.$message.error('至少保留一组样品!')
      }
      if (index == this.sampleList.length - 1 && index == this.currentSampleIndex) {
        this.currentSampleIndex = 0
      }
      this.sampleList.splice(index, 1)
    },
    addSample() {
      this.sampleList.push({
        formList: JSON.parse(JSON.stringify(this.initFormList))
      })
      this.currentSampleIndex = this.sampleList.length - 1
    },
    paySubmit() {
      if ([1, 2].includes(Number(this.form.payType))) {
        this.showQrcodeForm = true;
      }
    },
    resetPayPassword() {
      this.showResetPayPasswordForm = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.test-reservation-wrap {
  width: 100%;
  background-color: #F4F8F9;
  display: grid;
  grid-template-columns: 940px 242px;
  column-gap: 17px;
  padding-top: 30px;
  justify-content: center;

  .reservation-info {
    width: 100%;
    background-color: white;
    margin-bottom: 20px;

    .content {
      font-size: 14px;
      font-weight: 400;
      color: #343A40;
      line-height: 25px;
      padding: 21px 31px 30px 43px;
    }
  }

  .reservation-step {
    // padding-top: 20px;
    padding-bottom: 283px;

    .step-form-card {
      margin-top: 7px;

      .form-header {
        width: 100%;
        padding: 15px 17px 15px 43px;
        box-sizing: border-box;
        display: flex;
        align-items: baseline;
        justify-content: space-between;
        background-color: white;
        border-bottom: 1px solid #a7acb22e;

        .addSample {
          border-radius: 5px;
          padding: 8px 20px;
          min-width: fit-content;
        }

        .sample-list {
          display: flex;
          column-gap: 28px;
          row-gap: 10px;
          flex-wrap: wrap;

          .sample {
            font-size: 20px;
            font-weight: bold;
            color: #222222;
            cursor: pointer;

            .close {
              color: #A0A9AC !important;
              margin-left: 22px;
              cursor: pointer;
            }
          }

          .sample-sel {
            color: #00B4E8 !important;

            .close {
              color: #00B4E8 !important;
            }
          }
        }
      }

      .my-form {
        width: 100%;
        background: #ffffff;
        padding: 16px 97px 36px 43px;
        box-sizing: border-box;

        .form-item {
          grid-template-columns: 2fr 12fr;
          margin-bottom: 10px;

          label {
            line-height: 45px;
          }
        }

        .form-text-red {
          color: #FF6666;
          font-size: 10px;
          font-weight: 400;
          margin-top: 5px;
        }
      }
    }

    .attr-info {
      margin-top: 7px;

      .my-form {
        width: 100%;
        background: #ffffff;
        padding: 36px 97px 36px 43px;
        box-sizing: border-box;

        .form-item {
          grid-template-columns: 3fr 13fr;       

          label {
            line-height: 45px;
          }
        }

        .form-text-red {
          color: #FF6666;
          font-size: 10px;
          font-weight: 400;
          margin-top: 5px;
        }

        .sampleSendType1 {
          margin-top: 15px;
          padding-top: 20px;
          border-top: 1px solid #CCD7DB;

          .title {
            font-size: 14px;
            font-weight: 300;
            color: #222222;
          }

          .address-list {
            display: flex;
            align-items: center;
            gap: 10px;
            margin-top: 10px;

            .item {
              padding: 5px 8px;
              font-size: 14px;
              font-weight: 300;
              color: #A0A9AC;
              border-radius: 4px;
              border: 1px solid #CCD7DB;
              cursor: pointer;
            }

            .active {
              background: #00B4E8;
              color: white;
              border: none;
            }
          }

          .active-address-detail {
            width: 100%;
            padding: 23px 22px;
            box-sizing: border-box;
            font-size: 14px;
            color: #333333;
            line-height: 28px;
            background: #F4F8F9;
            margin-top: 10px;
            border-radius: 4px;
          }
        }

        .sampleSendType2 {
          display: flex;
          flex-direction: column;
          row-gap: 18px;
          margin-top: 15px;
          padding-top: 20px;
          border-top: 1px solid #CCD7DB;

          .form-item {
            grid-template-columns: 1fr 10fr;
          }
        }
      }
    }

    .settlement-wrap {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 40px;
      width: 100%;
      user-select: none;

      .cost {
        padding-left: 43px;

        .cost-title {
          color: #6F7F84;
          font-size: 16px;
        }

        .cost-num {
          color: #FF6666;
          font-weight: bold;
          font-size: 24px;
        }

        .cost-detail {
          font-size: 16px;
          font-weight: 400;
          color: #00B4E8;
          margin-left: 39px;
          cursor: pointer;

          span {
            font-weight: 100;
            transition: transform 0.3s ease-in-out;
          }

          span.rotate {
            /* 旋转后的状态 */
            transform: rotate(180deg);
          }
        }

      }

      .btns {
        display: flex;
        align-items: center;
        column-gap: 25px;

        .save-btn {
          padding: 11px 40px;
          border-radius: 25px;
          border: 1px solid #A0A9AC;
          background: #F4F8F9;
          font-size: 20px;
          font-weight: 400;
          color: #222222;
          cursor: pointer;
        }

        .next-btn {
          padding: 11px 40px;
          border-radius: 25px;
          font-size: 20px;
          font-weight: 400;
          color: #FFFFFF;
          background: #00B4E8;
          cursor: pointer;
        }
      }
    }

    .wait-pay-info {
      margin-top: 7px;

      .content {
        padding: 15px 20px 59px 20px;
        box-sizing: border-box;
        width: 100%;
        background: #ffffff;

        .cost-list {
          background: #F4F8F9;
          border-radius: 4px;
          padding: 21px 22px 40px 22px;
          width: 100%;
          box-sizing: border-box;

          .title {
            width: 100%;
            font-size: 16px;
            font-weight: bold;
            color: #222222;
            padding-bottom: 17px;
            border-bottom: 1px solid #CCD7DB;
            box-sizing: border-box;
          }

          .cost-item {
            width: 100%;
            padding: 15px 0;
            border-bottom: 1px solid #CCD7DB;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 14px;
            font-weight: 400;
            color: #333333;
          }

          .cost-total {
            font-size: 16px;
            font-weight: bold;
            color: #222222;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 31px;
          }
        }
      }
    }

    .pay-type {
      margin-top: 20px;

      .pay-type-wrap {
        width: 100%;
        padding: 25px 42px 49px 42px;
        box-sizing: border-box;
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        background-color: #FFFFFF;

        .pay-type-title {
          display: flex;
          align-items: center;
          column-gap: 35px;
          margin-bottom: 9px;
        }

        .tip {
          font-size: 14px;
          font-weight: 300;
          color: #A0A9AC;

          i {
            color: #00B4E8;
          }
        }

        .under-line {
          border-bottom: 1px solid #a7acb22c;
          margin-bottom: 15px;
        }

        .pay-password {
          .password-inp {
            display: flex;
            align-items: center;
            column-gap: 20px;
            margin-bottom: 10px;

            i {
              color: #00B4E8;
              cursor: pointer;
            }
          }
        }

        .form-check {
          display: grid;
          grid-template-columns: 18px auto;
          align-items: center;
          column-gap: 0;
          line-height: initial;
          padding: 9px 0;

          .custom-label {
            display: flex;
            align-items: center;
            font-size: 14px;
            font-weight: 300;
            color: #333333;

            &>img {
              width: 30px;
              height: 30px;
              margin-left: 20px;
              margin-right: 20px;
            }
          }

          .total-num {
            text-align: end;
            font-size: 14px;
            font-weight: 300;
            color: #222222;

            i {
              font-size: 14px;
              font-weight: bold;
              color: #FF6666;
            }
          }
        }
      }
    }
  }

}



.dropdown-menu {
  margin-top: 10px;
  background: #FFFFFF;
  padding: 18px 27px 27px 40px;
  box-sizing: border-box;

  .test-name {
    font-size: 16px;
    font-weight: bold;
    color: #222222;
    margin-bottom: 15px;
  }

  .test-item {
    width: 100%;
    font-size: 14px;
    font-weight: 400;
    color: #333333;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
  }

  .total-cost {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 24px;

    .total-cost-title {
      font-size: 16px;
      font-weight: bold;
      color: #222222;
    }

    .total-cost-num {
      font-size: 20px;
      font-weight: bold;
      color: #FF6666;
    }
  }
}

.el-form-item {
  margin-bottom: 10px;
}
</style>
